import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'

import Form from './Form'
import { SCHEMAS } from '../../class/constants'
import { acPostLogin, acMailVerificationRequest, acClearLoginErrorState } from '../../class/actions'

function LoginForm({ classes, loginError, requestMailVerification }) {
  const [customerEmail, setCustomerEmail] = useState('')
  const [successRequestVerification, setSuccessRequestVerification] = useState(null)
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const login = loginFormBody => {
    setCustomerEmail(loginFormBody.login)
    return dispatch(acPostLogin(loginFormBody))
      .catch(error => console.error(error))
  }

  const doRequestMailVerification = () => {
    return dispatch(acMailVerificationRequest({
      email: customerEmail
    }))
      .then(dispatch(acClearLoginErrorState()))
      .catch(error => console.error(error))
  }

  useEffect(() => {
    if (requestMailVerification) {
      setSuccessRequestVerification(true)
    }
  }, [requestMailVerification])

  const getRequestVerificationMsg = () => {
    return (
      <>
        {t('screens.loginScreen.requestVerificationSuccess')}
        <span></span>
      </>
    )
  }

  const getErrorMsg = () => {
    if (!loginError) { return '' }

    switch (loginError.description) {
      case 'USER_NOT_FOUND':
        return t('screens.loginScreen.errors.400');
      case 'EMAIL_NOT_VERIFIED':
        return (
          <>
            {t('screens.loginScreen.errors.unverifiedEmail')}
            <span> </span>
            <span className={classes.spn} onClick={() => doRequestMailVerification()}>
              {t('screens.loginScreen.clickingHereBtn').toLowerCase()}
            </span>
          </>
        );
      default:
        return t('screens.loginScreen.errors.common');
    }
  }

  return (
    <Form
      onSubmit={login}
      initialValues={{ login: '', password: '' }}
      schema={SCHEMAS.LOGIN}
      btnText={t('forms.login.btn')}
      errorMsg={getErrorMsg()}
      successMsg={successRequestVerification ? getRequestVerificationMsg() : null}
      fields={[{
        type: 'text',
        id: 'login',
        label: t('forms.login.login'),
        variant: 'filled',
        light: 'light',
        required: true
      }, {
        type: 'password',
        id: 'password',
        label: t('forms.login.password'),
        password: true,
        variant: 'filled',
        light: 'light',
        required: true,
      }]}
    />
  )
}

LoginForm.propTypes = {

}

LoginForm.defaultProps = {

}

const styles = theme => ({
  spn: {
    cursor: 'pointer',
    fontWeight: 'bold'
  }
})

const mapStateToProps = state => ({
  loginError: state.ReducerAuth.loginError,
  requestMailVerification: state.ReducerAuth.requestMailVerification,
})

export default connect(mapStateToProps)(withStyles(styles)(LoginForm));